import { render, staticRenderFns } from "./subscripers.vue?vue&type=template&id=c6bfdc88&scoped=true&"
import script from "./subscripers.vue?vue&type=script&lang=js&"
export * from "./subscripers.vue?vue&type=script&lang=js&"
import style0 from "./subscripers.vue?vue&type=style&index=0&id=c6bfdc88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bfdc88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
